import Axios from 'axios'
import { API_HOST,axiosRequestWithAuth,axiosInstance } from './../constants/server.constant';
import { getFullRegionDetail } from '../utility/utility';
import SessionService from './session.service';
export const SshkeyService = {
    getSshKeyList,
    addSshKey,
    deleteSshKey,
    getSshKeyDetails
}

function getuserId(){
    return localStorage.getItem("userId")
}

/*async function getSshKeyList(){
     return await Axios.get(API_HOST+"/ssh/getall/"+getuserId()
        ,axiosRequestWithAuth)
          .then(resp=>{
             let sshkeys = []
             let region = []
             let arr = []
             let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
             for(var key of Object.keys(resp.data))
             {
                region.push(key)
                let sshlist = resp.data[key]
                if(sshlist  === null) {
                    continue;
                }
                let fullRegion = getFullRegionDetail(fullRegionList,key)
                sshlist.forEach(sshkey =>{

                    let d = new Date(sshkey.created_at);
                    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });

                    sshkeys.push({
                        name : sshkey.keypair.name,
                        fingerprint : sshkey.keypair.fingerprint,
                        created : createdDate,
                        regionname : key,
                        fullRegion:fullRegion
                    })
                })
             }
             arr.push(sshkeys)
             arr.push(region)
            return arr
          }) 
          .catch((err)=>{
           
              return []
          })

}*/


async function getSshKeyList(type){
    return await axiosInstance.get(API_HOST+"/ssh/v1/getall/"+type+"/"+getuserId()
       ,axiosRequestWithAuth)
         .then(resp=>{
            
            let data = resp.data
            
            let result = []
            if(data === "INVALID_CREATOR"){
                return data
            }

            for(let i=0;i<data.length;i++){
                let UTCtime = data[i].created+"Z"
                let d = new Date(UTCtime);
                let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                });
                
                result.push({
                    name : data[i].name,
                    date : createdDate,
                    secretref : data[i].secretref.split("/").pop()
                })

            }
            return result
         }) 
         .catch((err)=>{
          
             return []
         })

}

async function addSshKey(name,sshkey){
     let data = {
        "name": name,
        "payload_content_type": "text/plain",
        "secret_type" : "opaque",
        "algorithm": "aes",
        "mode": "cbs",
        "bit_length" : 256,
        "payload": sshkey

    }

    return await axiosInstance.post(API_HOST+"/ssh/create/v1/"+getuserId(),JSON.stringify(data),axiosRequestWithAuth)
                      .then(resp=>{
                          return resp
                      })
                      .catch(err=>{
                          return false
                      })
}

/*async function addSshKey(data,region){
    return await Axios.post(API_HOST+"/ssh/"+region+"/"+getuserId(),data,axiosRequestWithAuth)
                      .then(resp=>{
                          return resp
                      })
                      .catch(err=>{
                          return false
                      })
}*/

/*async function deleteSshKey(requestBody,region){
    requestBody = JSON.stringify(requestBody);
    var reqHeaders = axiosRequestWithAuth;
    reqHeaders.data = requestBody;
    return await Axios.delete(API_HOST+"/ssh/"+region+"/"+getuserId(),reqHeaders)
                      .then(resp=>{
                          return resp
                      })
                      .catch(err=>{
                          return false
                      })
}*/
async function deleteSshKey(requestBody){
    
    requestBody = JSON.stringify(requestBody);

    var reqHeaders = axiosRequestWithAuth;
    reqHeaders.data = requestBody;
    return await axiosInstance.delete(API_HOST+"/ssh/delete/v1/"+getuserId(),reqHeaders)
                      .then(resp=>{
                          return resp
                      })
                      .catch(err=>{
                          return false
                      })
}

/*async function getSshKeyDetails(name,region){
    
   
    return await Axios.get(API_HOST+"/ssh/"+region+"/"+name+"/"+getuserId(),axiosRequestWithAuth)
                      .then(resp=>{
                          return resp
                      })
                      .catch(err=>{
                          return false
                      })
}*/
async function getSshKeyDetails(uuid){
    
   
    return await axiosInstance.get(API_HOST+"/ssh/v1/getsshkey/"+getuserId()+"?uuid="+uuid,axiosRequestWithAuth)
                      .then(resp=>{
                          return resp
                      })
                      .catch(err=>{
                          return false
                      })
}

